import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureMinus1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_minus_1"}/>
}
